import {Injectable} from '@angular/core';
import {Resolve, ActivatedRouteSnapshot, Router, NavigationExtras} from '@angular/router';
import {Observable, EMPTY} from 'rxjs';
import {CampaignService} from "./campaign.service";
import {EventBusService} from '@signature-it/ngx-generic/services';
import {EventData, EventName} from '@signature-it/ngx-generic/classes';
@Injectable({
    providedIn: 'root'
})
export class CampaignResolver  {

    constructor(private router: Router,
                protected campaignSvc: CampaignService,
                protected eventBusService: EventBusService) {
    }

    resolve(route: ActivatedRouteSnapshot): Observable<any> {
        const campaign = route.queryParams.campaign;
        return new Observable(observer => {
            if (campaign) {
                this.eventBusService.emit(new EventData(EventName.DATA_FOR_ANALYTICS_READY, {page: 'campaign', data: campaign}));
                this.campaignSvc.getCampaignData(campaign).subscribe(campaignData => {
                    if (!campaignData?.length) {
                        const navigationExtras = {
                            queryParams: {},
                            queryParamsHandling: 'merge',
                            skipLocationChange: true
                        };
                        this.router.navigate(['catalogue/group/1']);
                    } else {
                        observer.next(campaignData);
                    }
                    observer.complete();
                });
            } else {
                observer.next(EMPTY);
                observer.complete();
            }
        });
    }
}

